module.exports = __webpack_public_path__ + "img/title1.3b139faf.jpg";